// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// GLOBAL IMPORTS
import Vue from "vue";

// IMPORT internal dependencies and plugins
import App from "@/pages/App";             // Basic template
import router from "@/routes/router";      // global router
import store from "@/store";               // global state
import i18n from "@/plugins/i18n.js";      // internationalization
import "@/plugins/vuetify.js";             // vuetify style
import VueSanitize from "vue-sanitize";

Vue.use(VueSanitize);


// IMPORT configurations
import "@/config/loggerConfig.js";         // logger configuration

// VUE Configuration
Vue.config.productionTip = false;

/*Vue.use(VueAnalytics, {
    id: 'UA-65641226-7',
    router
})*/

// Declare Vue instance
let app = new Vue({
    data: {
        appName: "IVE frontend application",
    },
    render: h => h(App),
    i18n,
    store,
    router,
}).$mount("#app");

export const vm = app;
